export enum ArkoseGateVerifyOrBypassScreenNames {
  ARKOSE_GATE = 'Arkose gate',
}

export type ArkoseGateVerifyOrBypassScreenName =
  (typeof ARKOSE_GATE_VERIFY_OR_BYPASS_CUSTOM_SCREEN_NAMES)[number];

export const ARKOSE_GATE_VERIFY_OR_BYPASS_SCREEN_IDS = {
  ARKOSE_GATE: 'SC3ArkoseGateVerifyOrBypass',
} as const;

export const ARKOSE_GATE_VERIFY_OR_BYPASS_CUSTOM_SCREEN_NAMES = [
  ArkoseGateVerifyOrBypassScreenNames.ARKOSE_GATE,
] as const;

export const isArkoseGateVerifyOrBypassScreen = (
  screenName: string
): screenName is ArkoseGateVerifyOrBypassScreenName =>
  ARKOSE_GATE_VERIFY_OR_BYPASS_CUSTOM_SCREEN_NAMES.includes(
    screenName as ArkoseGateVerifyOrBypassScreenName
  );
